var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: _vm.routeName },"exact":_vm.exact}},[(!_vm.materialIcon)?_c('i',{class:_vm.icon}):_c('i',{class:{ 'material-icons': true, squaredMaterial: _vm.squaredMaterial }},[_vm._v(_vm._s(_vm.icon))]),_c('span',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }